var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('Rating',{attrs:{"dataSelected":_vm.dataSelected,"bookingIdentifierNo":_vm.bookingIdentifierNo}}),(_vm.error !== '')?_c('div',{staticClass:"error",staticStyle:{"display":"block"}},[_c('br'),_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }